import React,{ Component } from 'react';
import {Row, Col, Button, FormGroup} from 'react-bootstrap';
import FieldGroup from '../../../../components/FieldGroup';
import SelectWrap from "../../../../components/SelectWrap";
import { handleFieldChange } from "../../../../Utils";
import countriesObj from "../../../../data/countries";

const countriesOptions = Object.assign({ all: 'All' }, countriesObj);

class Filters extends Component {
    constructor(props) {
        super(props);

        this.state = {
            affid: null,
            subid: null,
            country: null,
            minCutoff: null,
            maxCutoff: null
        };

        this.handleFieldChange = handleFieldChange.bind(this);
        this.handleFormSubmit = this.handleFormSubmit.bind(this);
    }

    handleFormSubmit(e, type) {
        e.preventDefault();

        this.props.onSubmit(this.state, type);
    }

    render() {
        return (
            <form>
                <Row>
                    <Col lg={6}>
                        <SelectWrap
                            values={this.props.affidValues}
                            label="Affid:"
                            name="affid"
                            onChange={this.handleFieldChange}
                            value={this.state.affid}
                            multi
                        />
                    </Col>
                    <Col lg={6}>
                        <SelectWrap
                            values={this.props.subidValues}
                            label="Subid:"
                            name="subid"
                            onChange={this.handleFieldChange}
                            value={this.state.subid}
                            disabled={!this.props.subidValues.length || !this.state.affid || !this.state.affid.length}
                            multi
                        />
                    </Col>
                    <Col lg={4}>
                        <SelectWrap
                            values={countriesOptions}
                            label="Countries:"
                            name="country"
                            onChange={this.handleFieldChange}
                            value={this.state.country}
                            multi
                        />
                    </Col>
                    <Col lg={4}>
                        <FieldGroup
                            type="number"
                            name="minCutoff"
                            label="Min. Cutoff:"
                            step={0.01}
                            onChange={this.handleFieldChange}
                            value={this.state.minCutoff}
                        />
                    </Col>
                    <Col lg={4}>
                        <FieldGroup
                            type="number"
                            name="maxCutoff"
                            label="max. Cutoff:"
                            step={0.01}
                            onChange={this.handleFieldChange}
                            value={this.state.maxCutoff}
                        />
                    </Col>
                </Row>
                <FormGroup>
                    <Button onClick={(e) => this.handleFormSubmit(e)} bsStyle="info" className="m-b-15" >Apply</Button>
                    <Button onClick={(e) => this.handleFormSubmit(e, 'subid')} bsStyle="info" className="m-b-15" disabled={!this.state.affid || !this.state.affid.length}>Load Subid</Button>
                </FormGroup>
            </form>
        );
    }
}

export default Filters;


// WEBPACK FOOTER //
// ./src/scenes/DummyCutoffAll/components/Form/index.js